import React from 'react';
import { Link as RRDLink, type LinkProps } from 'react-router-dom';
import { useHandleLinkClick } from './useHandleLinkClick';

export const Link: React.FC<LinkProps> = ({
    to, onClick, target, ...restProps
}) => {
    const handleClick = useHandleLinkClick({ to, onClick, target });

    return (
        <RRDLink
            to={to}
            onClick={handleClick}
            target={target}
            {...restProps}
        />
    );
};

export * from './NavLink';